export default {
      id: "flag-se-usage",
      viewBox: "0 10 36 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#flag-se",
      toString: function () {
        return this.url;
      }
    }